import { render, staticRenderFns } from "./pointApply.vue?vue&type=template&id=ac9214ce&scoped=true&"
import script from "./pointApply.vue?vue&type=script&lang=js&"
export * from "./pointApply.vue?vue&type=script&lang=js&"
import style0 from "./pointApply.vue?vue&type=style&index=0&id=ac9214ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9214ce",
  null
  
)

export default component.exports